import { useEffect } from 'react';
import {
  HubConnectionBuilder,
  HubConnectionState,
  LogLevel,
  HttpTransportType,
} from '@microsoft/signalr';

export default function useSignalR(url, channel, onReceiveMessages) {
  useEffect(() => {
    // Set when this connection goes away on purpose (logout, branch change, leaving the layout). A
    // connection stopped on purpose is not brought back - neither by its close handler nor by the
    // retry after a failed start - where a dropped one still is, if it has a channel.
    let stopped = false;
    const connection = new HubConnectionBuilder()
      .withUrl(url, {
        transport: HttpTransportType.WebSockets,
        logMessageContent: true,
        logger: LogLevel.Trace,
      })
      .configureLogging(LogLevel.Information)
      .build();
    onReceiveMessages.forEach((m) => connection.on(m.eventName, m.callback));

    async function start() {
      if (stopped || connection.state !== HubConnectionState.Disconnected)
        return;
      try {
        console.info('SignalR Try to connect', connection.state);
        await connection.start();
        console.info('SignalR Connected');
        if (channel) {
          connection
            .invoke('SubscribeToChannel', channel.toLowerCase())
            .catch((err) => console.error(err));
        }
      } catch (err) {
        if (stopped) return;
        console.error(err);
        setTimeout(start, 5000);
      }
    }

    connection.onclose(() => {
      if (channel) start();
    });
    start();
    return () => {
      stopped = true;
      connection.stop().catch((err) => console.error(err));
    };
  }, [channel]);
}
